
export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_applyNo') || '验货需求单号',
    field: 'applyNo',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_applyStatus') || '状态',
    field: 'applyStatus',
    minWidth: 90,
    align: 'center',
    slots: { default: 'applyStatus' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_inspectionResult') || '验货结果',
    field: 'inspectionResult',
    minWidth: 90,
    align: 'center',
    slots: { default: 'inspectionResult' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_applyUserName') || '申请人',
    field: 'applyUserName',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_depName') || '申请部门',
    field: 'depName',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orgName') || '申请人公司',
    field: 'orgName',
    minWidth: 220,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_applyDate') || '申请日期',
    field: 'applyDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_urgencyLevel') || '紧急程度',
    field: 'urgencyLevel',
    minWidth: 90,
    align: 'center',
    slots: { default: 'urgencyLevel' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_applyReason') || '申请事由',
    field: 'applyReason',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '下单客户',
    field: 'custName',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_orderNos') || '客户PO#',
    field: 'orderNos',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_deliveryDeadline') || '订单交期',
    field: 'deliveryDeadline',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_inspectionTime') || '验货时间',
    field: 'inspectionTime',
    width: 190,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'inspectionTime' },
  },
  {
    title: that.$l('table_label_inspectionFactory') || '验货工厂',
    field: 'scmName',
    minWidth: 210,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_inspectionAddress') || '验货地址',
    field: 'inspectionAddress',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_hxInspectionRoom') || '验货间',
    field: 'hxInspectionRoomText',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_productName') || '品名',
    field: 'productName',
    minWidth: 140,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_styleCount') || '款数',
    field: 'styleCount',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderTotalQty') || '产品数量',
    field: 'orderTotalQty',
    minWidth: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
]

